const Mission = () => {
  return (
    <div className="three bg-gray">
      <div className="three-block">
        <p className="subtitle gray pry-text">STATEMENT</p>
        <p className="header purple pry-text center">
          <span className="gray">Our</span> Mission{" "}
          <span className="gray">and</span> Vision <br />
          <span className="gray">statement at</span> Noble
          <br /> Guard Security.
        </p>
      </div>
      <div className="mission">
        <div className="mish">
          <p className="subtitle red pry-text">MISSION STATEMENT</p>
          <p className="charcoal pry-text title justify">
            "
            <span className="purple">
              Safety, Assurance, Sustainable Environment:
            </span>{" "}
            Safety being our top most priority, we aim to provide quality
            security services thereby ensuring a sustainable and safe
            environment."
          </p>
        </div>
        <div className="vish">
          <p className="subtitle red pry-text">VISION STATEMENT</p>
          <p className="charcoal pry-text title justify">
            "
            <span className="purple">
              Lighting Pathways to a Fear-Free Future:
            </span>{" "}
            To be Africa’s No 1 security company by creating a nation where
            every life is secured ensuring a suitable environment free of fear
            and terror."
          </p>
        </div>
        <div className="mish">
          <p className="subtitle red pry-text">CORE VALUES</p>
          <p className="charcoal pry-text title justify">
            "<span className="purple">Guarding with Grace: Our 4Hs -</span>{" "}
            Humility, Hardwork, Honesty, and High Quality; Serves as our guiding
            principles."
          </p>
        </div>
      </div>
    </div>
  );
};

export default Mission;
